import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";

import "./../constants/routes";

import Header from "../components/header/header";
import Footer from "../components/footer/footer";

import "./styles.scss";

const Layout = () => {
  const { pathname } = useLocation();

  // Scroll to top when route changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="Layout">
      <Header />
      <div className="Layout-content">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
